module.exports = { "default": require("core-js/library/fn/number/epsilon"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/epsilon.js
// module id = 1448
// module chunks = 0